<template>
  <div class="myliveroom wrapper">
    <div class="tab-layer">
      <div class="tab" :class="{'active': status == -1}" @click="chgTab(-1)">全部</div>
      <div class="tab" :class="{'active': status == 0}" @click="chgTab(0)">未开始</div>
      <div class="tab" :class="{'active': status == 1}" @click="chgTab(1)">进行中</div>
      <div class="tab" :class="{'active': status == 2}" @click="chgTab(2)">已完成</div>
      <div class="tab" :class="{'active': status == 3}" @click="chgTab(3)">已取消</div>
    </div>

    <div class="content" ref="contentLayer">
      <!--发布list-->
      <div class="common-nodata-item" v-if="noData">
        <div class="no-live">
          <img src="http://assets.rurushishi.com/yq-rs-desk/no-live.png" alt />
        </div>您还没有相关的直播
      </div>
      <mt-loadmore :bottom-method="loadMore" :bottom-all-loaded="!hasMore" ref="loadmore">
        <div class="list">
          <div
            class="live-layer border-bottom"
            v-for="(project,projectIndex, index) in list"
            :key="index"
            @click="tapProject(project)"
          >
            <div class="left-layer">
              <img v-lazy="project.bannerImgUrl" />
              <div
                class="status"
                :class="{'x1': project.status == 1, 'x2': project.status == 2, 'x3': project.status == 3}"
              >{{statusArr[project.status]}}</div>
            </div>
            <div class="right-layer">
              <div class="title">{{project.roomName}}</div>
              <div class="text">直播人：{{project.anchorName}}</div>
              <div class="text">预计开始时间：{{project.planDateToStart}} {{project.planTimeToStart}}</div>
              <div class="text c2">创建时间：{{project.createTime}}</div>
            </div>
          </div>
        </div>
      </mt-loadmore>
      <div class="common-nodata-item" v-if="allLoad">已加载全部数据</div>
    </div>

    <div class="tabbar">
      <div class="btn" @click="createLiveRoom">
        <span>
          <img src="http://assets.rurushishi.com/yq-rs-desk/icon-creat-live.png" alt />
        </span>创建直播
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import * as config from "./config";
import { Loadmore, MessageBox } from "mint-ui"; //上拉刷新
import { mapState, mapMutations } from "vuex";
import Vue from "vue";
import Cookies from "js-cookie";
Vue.component(Loadmore.name, Loadmore);

export default {
  components: {},
  props: {},
  data() {
    return {
      status: -1,
      statusArr: ["未开始", "进行中", "已完成", "已取消"],
      //列表
      noData: false,
      allLoad: false,
      hasMore: true,
      loading: true,
      page: 1,
      size: 20,
      list: [],
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "pageInfo",
      "isInMiniProgram",
      "shareSpreadInfo",
      "receiveSpreadInfo",
      "isLoading",
    ]),
  },
  methods: {
    ...mapMutations({
      SET_ISLOADING: "SET_ISLOADING",
    }),
    chgTab(type) {
      let that = this;
      if (type == that.status) {
        return;
      }
      that.status = type;
      that.query();
    },
    query() {
      let that = this;
      that.list = [];
      that.page = 1;
      that.size = 20;
      that.hasMore = true;
      that.loading = true;
      that.noData = false;
      that.allLoad = false;
      that.loadData();
    },
    loadMore() {
      const that = this;
      if (that.hasMore && !that.loading) {
        that.page++;
        that.loadData();
      }
    },
    loadData() {
      let that = this;
      that.loading = true;
      let params = {
        // publicOpenId: Cookies.get('openid'),
        page: that.page,
        size: that.size,
      };
      if (that.status != -1) {
        params.status = that.status;
      }
      util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
        config.myLiveRoom(params).then((response) => {
          if (response.code == 0) {
            if (response.data.records == 0 && response.data.page == 1) {
              that.list = [];
              that.noData = true;
            } else {
              that.$refs.loadmore.onBottomLoaded();
              that.noData = false;
              that.loading = false;
              let list = [];
              response.data.content.forEach((e) => {
                list.push(e);
              });
              that.list = that.list.concat(list);
              if (!response.data.hasMore) {
                that.hasMore = false;
                that.allLoad = true;
              }
              if (that.page == 1) {
                that.$nextTick(() => {
                  that.$refs.contentLayer.scrollTop = 0;
                });
              }
            }
            console.log(that.list);
            console.log("直播间数据>>>>>", response.data);
          } else {
            return MessageBox("提示", response.msg);
          }
        });
      });
    },
    createLiveRoom() {
      let url = `${location.protocol}//${location.host}/h5/live/chkproject`;
      util.openYqRsMakeLink(url);
    },
    tapProject(content) {
      let that = this;
      config.promotionInfo(content.roomId).then((data) => {
        if (data.code == 0 && data.data) {
          util.openYqRsMakeLink(
            util.addUrlParamFromObj(
              `${location.protocol}//${location.host}/h5/live/liveroominfo`,
              {
                rid: content.roomId,
                id: data.data.pageId,
                psn: data.data.psn,
                t9id: that.receiveSpreadInfo.id,
                t9psn: that.receiveSpreadInfo.psn,
                pid: content.projectId,
              }
            )
          );
        }
      });
    },
  },
  created() {},
  mounted() {
    let that = this;
    that.$nextTick(function () {
      that.loadData();
    });
  },
};
</script>
<style lang="css" scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-color: #ffffff;
}
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0.85rem;
  bottom: 1.2rem;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.common-nodata-item {
  line-height: 0.8rem;
  font-size: 0.24rem;
  color: #212121;
  text-align: center;
}
.no-live {
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 0.4rem;
}
.no-live > img {
  width: 3.14rem;
  height: 2.28rem;
}
.wrapper .tab-layer {
  display: flex;
  align-items: center;
  line-height: 0.8rem;
  height: 0.8rem;
  font-size: 0.28rem;
  color: #666666;
  font-weight: 500;
}

.wrapper .tab-layer .tab {
  flex: 1;
  text-align: center;
  position: relative;
}

.wrapper .tab-layer .tab.active {
  color: #f75302;
}

.wrapper .tab-layer .tab.active:after {
  position: absolute;
  content: "";
  width: 1rem;
  height: 3px;
  background-color: #f75302;
  bottom: 0;
  left: 50%;
  margin-left: -0.5rem;
}
.tabbar {
  width: 100%;
  height: 1.2rem;
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-top: 1px solid #c6c6c6;
}
.tabbar .btn {
  width: 80%;
  height: 0.88rem;
  background-color: #f75302;
  color: #ffffff;
  font-size: 0.28rem;
  text-align: center;
  line-height: 0.88rem;
  border-radius: 8px;
}
.tabbar .btn > span {
  display: inline-block;
  width: 0.5rem;
}
.tabbar .btn > span > img {
  width: 0.3rem;
  height: 0.3rem;
}

.wrapper .live-layer {
  padding: 0.2rem 0.3rem;
  display: flex;
  align-items: center;
}

.live-layer .left-layer {
  max-width: 2.8rem;
  min-width: 2.8rem;
  height: 1.8rem;
  position: relative;
}
.live-layer .left-layer .status {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.2rem;
  color: #fff;
  padding: 3px 6px;
  background-color: #7d7976;
}
.live-layer .left-layer .status.x1 {
  background-color: #f75302;
}
.live-layer .left-layer .status.x2 {
  background-color: #1f7cff;
}
.live-layer .left-layer > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.live-layer .right-layer {
  flex: 1;
  margin-left: 0.16rem;
}
.live-layer .right-layer .title {
  font-size: 0.3rem;
  color: #333333;
  line-height: 0.4rem;
}
.live-layer .right-layer .text {
  font-size: 0.26rem;
  color: #394157;
  margin-top: 8px;
}
.live-layer .right-layer .text.c2 {
  font-size: 0.24rem;
  color: #666666;
  margin-top: 8px;
}
</style>